  <div class="color-picker-container">
    <div class="color-input-group">
      <div
        class="color-cube"
        [style.background-color]="currentColor"
        (click)="openModal()"
      ></div>
      <input
        type="text"
        class="hex-input"
        [(ngModel)]="hexInput"
        (ngModelChange)="onHexInputChange()"
        maxlength="7"
      >
    </div>

    <div class="color-picker-modal" *ngIf="showModal">
      <div class="modal-content">
        <div class="color-display" [style.background-color]="currentColor"></div>

        <div class="sliders-container">
          <div class="slider-group hue-slider-group">
            <label>Цветовой тон</label>
            <canvas
              #hueSlider
              class="hue-slider"
              width="300"
              height="30"
              (mousedown)="onHueSliderMouseDown($event)"
              (click)="onHueSliderClick($event)"
            ></canvas>
          </div>

          <div class="slider-group saturation-slider-group">
            <label>Насыщенность</label>
            <canvas
              #saturationSlider
              class="saturation-slider"
              width="300"
              height="30"
              (mousedown)="onSaturationSliderMouseDown($event)"
              (click)="onSaturationSliderClick($event)"
            ></canvas>
          </div>

          <div class="slider-group lightness-slider-group">
            <label>Яркость</label>
            <canvas
              #lightnessSlider
              class="lightness-slider"
              width="300"
              height="30"
              (mousedown)="onLightnessSliderMouseDown($event)"
              (click)="onLightnessSliderClick($event)"
            ></canvas>
          </div>
        </div>

        <div class="actions">
          <button class="save-button" (click)="saveColor()">Сохранить</button>
        </div>
      </div>
    </div>
  </div>

